import React, { useState } from 'react';
import { Checkbox } from 'primereact/checkbox';
import cn from 'classnames';

const MultiCheckboxField = ({ field, form, options, className }) => {
  const [selectedValues, setSelectedValues] = useState(field.value || []);

  const handleChange = (e) => {
    let _selectedValues = [...selectedValues];

    if (e.checked) {
      _selectedValues.push(e.value);
    } else {
      _selectedValues.splice(_selectedValues.indexOf(e.value), 1);
    }

    setSelectedValues(_selectedValues);
    form.setFieldValue(field.name, _selectedValues);
  };

  return (
    <div
      className={
        className
          ? cn(className, 'checkbox-field')
          : 'd-flex flex-wrap gap-3 checkbox-field'
      }
    >
      {options.map(({ name, label }) => (
        <div className="d-flex" key={name}>
          <Checkbox
            inputId={name}
            name={name}
            value={name}
            onChange={handleChange}
            checked={field.value.includes(name)}
          />
          <label htmlFor={name} className="mx-2 text-nowrap">
            {label}
          </label>
        </div>
      ))}
    </div>
  );
};

export default MultiCheckboxField;
